<template #content>

    <div class="w-full">
        <Toolbar class="mb-2 bg-gray-100">
            <template #end>
                <div class="flex items-center gap-1">
                    <Button icon="pi pi-plus" label="Incluir" severity="info" size="small" @click="openForm({
                        contrato_id: contrato.id,
                        velocidade: contrato.velocidade,
                        tipo_link: contrato.tipo_link,
                        sla: contrato.sla,
                        sla_nbd: contrato.sla_nbd,
                    })" />
                    <Button icon="pi pi-search" label="Buscar" severity="success" size="small" @click="toggleBusca" />
                    <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small" @click="loadData" />
                </div>
            </template>
        </Toolbar>

        <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
            scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
            @sort="onTableSort">

            <Column style="width: 100px" field="id" header="#" sortable></Column>
            <Column field="provedor" header="Provedor" sortable></Column>
            <Column field="valor" header="Valor" sortable>
                <template #body="{ data }">
                    R$ {{ formatMoney(data.valor) }}
                </template>
            </Column>
            <Column field="valor_com_desconto" header="Valor c/ Desconto" sortable>
                <template #body="{ data }">
                    R$ {{ formatMoney(data.valor_com_desconto) }}
                </template>
            </Column>
            <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
                <template #body="{ data }">
                    <Button icon="pi pi-check-square" title="Aprovação" size="small"
                        :severity="data.aprovado ? 'success' : 'danger'" @click="aprovacao(data)"
                        v-tooltip.top="data.aprovado ? 'Aprovado' : 'Reprovado'" />
                    <Button icon="pi pi-pen-to-square" title="Atualizar" class="p-button-rounded p-button-text p-button-info p-0 w-2rem h-2rem"
                        @click="openForm(data)" />
                    <Button v-if="permissoes.COTACAO_REMOVER" icon="pi pi-trash" title="Remover" class="p-button-rounded p-button-text p-button-danger p-0 w-2rem h-2rem" @click="remove(data)" />
                </template>
            </Column>

            <template #empty>
                <div class="text-center text-gray-600">
                    Nenhum registro encontrado
                </div>
            </template>
        </DataTable>

        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center">
                <div class="flex justify-end mt-2 text-sm text-gray-600">
                    <span>{{ pagination.total }} registros</span>
                </div>

            </div>
            <div class="flex align-items-center justify-content-center">
                <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                    @page="onPage">
                </Paginator>
            </div>
            <div class="flex align-items-center justify-content-center">
            </div>
        </div>

        <CotacaoForm :visible="visibleForm" :data="item" :permissoes="permissoes" @save="saveForm" @close="closeForm" />
        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">
                    <div class="w-full">
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['pro.nome']" class="w-full" />
                                <label>Provedor</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['cot.valor']" class="w-full" />
                                <label>Valor</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['cot.tipo_link']" class="w-full" />
                                <label>Tipo de Link</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText v-model="params.filter['cot.velocidade']" class="w-full" />
                                <label>Velocidade</label>
                            </FloatLabel>
                        </div>
                        <div class="field mt-4">
                            <FloatLabel>
                                <Select id="ativo" v-model="params.filter['cot.aprovado']" :options="statusOptions"
                                    optionLabel="label" optionValue="value" :showClear="true" class="w-full" />
                                <label for="ativo">Status</label>
                            </FloatLabel>
                        </div>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>
        </Popover>
    </div>

</template>
<script>

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';
import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import DatePicker from 'primevue/datepicker';

import Provedor from '@/service/provedor.js';
import Cotacao from '@/service/cotacao.js';

import CotacaoForm from '@/page/cotacao/Form.vue';

import Mask from '@/utils/Mask.js';
import Filter from '@/utils/Filter.js';

export default {
    components: {
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        MultiSelect,
        Select,
        DatePicker,

        /* Formulario */
        CotacaoForm,
    },
    props: {
        contrato: {},
        permissoes: {},
    },
    emits: ['save','aprovacao'],
    data() {
        return {
            isLoading: false,
            lista: [],
            item: {},
            visibleForm: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
            statusOptions: [
                { label: 'Aprovados', value: 1 },
                { label: 'Reprovados', value: 0 }
            ],

            provedorOpt: [],
            isLoadingProvedorOpt: false,

        }
    },
    mounted() {
        this.loadData();
        this.loadProvedorOpt();
    },
    beforeMount() {
        document.addEventListener("onContratoTabChange", event => {
            if(this.$refs.busca) {
                this.$refs.busca.hide()
            }
        });
    },
    methods: {
        formatMoney(valor) {
            if (!valor) return Mask.money(0);
            return Mask.money(valor);
        },
        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },
        saveForm() {
            this.$emit('save');
            this.loadData();
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Cotacao.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.saveForm();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        aprovacao(data) {
            this.$confirm.require({
                message: 'Deseja realmente mudar a aprovar da cotação?',
                header: 'Aprovação',
                acceptLabel: 'Aprovar',
                icon: 'pi pi-check-square',
                acceptClass: 'bg-blue-500 border-blue-400 text-white',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-500 border-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Cotacao.aprovacao(data.id, { aprovado: !data.aprovado })
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi aprovado com sucesso.', life: 3000 });
                            this.$emit('aprovacao', response.data.contrato);
                            this.saveForm();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;

                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Cotacao.listContrato(this.contrato.id, params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },
        loadProvedorOpt() {
            this.isLoadingProvedorOpt = true;
            Provedor.option(['order[nome]=asc'].join("&"))
                .then(response => {
                    this.provedorOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingProvedorOpt = false;
                });
        },
    }
}
</script>

<style>
.contrato-endereco .p-panel-header {
    padding-bottom: 0;
}
</style>
